import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { SERVICES, IMAGES } from "../mock";
import { fetchServices } from "../api";

const CATEGORIES = ["All", "Injectables", "Regenerative", "Skin", "Body", "Wellness"];

export default function Services() {
  const [cat, setCat] = useState("All");
  const [services, setServices] = useState(SERVICES);
  useEffect(() => {
    fetchServices().then((d) => { if (d && d.length) setServices(d); }).catch((e) => console.error("Services load failed:", e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useReveal([cat, services]);
  const list = cat === "All" ? services : services.filter((s) => s.category === cat);

  return (
    <main className="pt-20">
      <section className="relative py-32 bg-charcoal overflow-hidden">
        <div className="absolute inset-0 opacity-40">
          <img src={IMAGES.facial1} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/40" />
        </div>
        <div className="relative z-10 max-w-[1300px] mx-auto px-6 text-center">
          <span className="eyebrow text-gold">Our Treatments</span>
          <h1 className="font-display text-5xl lg:text-6xl font-light text-cream mt-5 leading-tight">
            A world of <span className="italic text-gold">refined</span> aesthetics
          </h1>
          <p className="font-sans text-cream/70 max-w-xl mx-auto mt-6 leading-relaxed">
            Explore our full menu of physician-led cosmetic and wellness treatments, each crafted for natural, lasting results.
          </p>
        </div>
      </section>

      <section className="bg-cream py-24">
        <div className="max-w-[1300px] mx-auto px-6">
          {/* Filters */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-16">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setCat(c)}
                className={`px-6 py-2.5 text-xs tracking-[0.16em] uppercase transition-all duration-300 border ${
                  cat === c ? "bg-charcoal text-cream border-charcoal" : "bg-transparent text-muted-ink border-gold/40 hover:border-gold hover:text-gold"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {list.map((s, i) => (
              <div key={s.id} className="lux-card group bg-white rounded-sm overflow-hidden flex flex-col sm:flex-row reveal" style={{ transitionDelay: `${(i % 2) * 90}ms` }}>
                <div className="img-zoom sm:w-2/5 h-56 sm:h-auto shrink-0">
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-7 flex flex-col">
                  <span className="eyebrow text-gold">{s.category}</span>
                  <h3 className="font-display text-2xl text-ink mt-2 leading-snug">{s.name}</h3>
                  <p className="font-sans text-muted-ink text-sm leading-relaxed mt-3 flex-1">{s.description}</p>
                  <div className="flex items-center justify-between mt-5 pt-5 border-t border-gold/20">
                    <div className="flex items-center gap-4 text-xs text-muted-ink">
                      <span className="text-gold font-medium tracking-wide uppercase">{s.price}</span>
                      <span className="flex items-center gap-1.5"><Clock size={13} /> {s.duration}</span>
                    </div>
                    <Link to="/contact" className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-ink hover:text-gold transition-colors">
                      Book <ArrowRight size={14} />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-charcoal py-20">
        <div className="max-w-2xl mx-auto px-6 text-center reveal">
          <h2 className="font-display text-3xl lg:text-4xl font-light text-cream">Not sure where to begin?</h2>
          <p className="font-sans text-cream/60 mt-4">Book a complimentary consultation and we’ll design a plan just for you.</p>
          <Link to="/contact" className="inline-block btn-gold mt-8">Book Free Consultation</Link>
        </div>
      </section>
    </main>
  );
}
